import http, { url } from '../../http'

const API_URL = "self_report_cm"

class communicationAPI {

  async getAll(  ) {
    const response = await http(`${API_URL}/type_document`)
    return response
  }

  /** Informe resumen anual de los auto-reportes de los trabajadores (ítem 2.8.1). */
  async summary(companyId, year) {
    return await http(`${API_URL}/summary/${companyId}?year=${year}`, 'GET')
  }

  /** URL directa del PDF del informe resumen (ruta abierta, sin firma). */
  summaryPdfUrl(companyId, year) {
    return url(`${API_URL}/summary/${companyId}/pdf?year=${year}`)
  }

}

export default new communicationAPI()